export default __webpack_public_path__ + "11a7d5c3527e6ed3d6387916bc7f28cf.svg";